/**
 * Plain `fetch` against the API base for endpoints the backend marks
 * with ``PUBLIC_ROUTE`` (i.e. ``GET /api/share/{token}``). Skips the
 * Bearer-attach + 401-refresh dance ``apiFetch`` does, because:
 *
 *   1. The recipient of a share link is often unauthenticated — they
 *      don't have a session to refresh.
 *   2. If they *are* authenticated, attaching an unrelated org's
 *      token still works (the backend ignores auth on PUBLIC_ROUTE),
 *      but threading the 401-refresh logic would force a logout on
 *      stale tokens for a route that doesn't need them. Safer to skip.
 */
import { API_BASE } from './apiFetch'

export function publicFetch(path: string, init: RequestInit = {}): Promise<Response> {
  return fetch(`${API_BASE}${path}`, init)
}
